export default __webpack_public_path__ + "locales/nl/ChangeUserStatusDialog.json?hash=533299bc34cba22ee24c121162e9eb00";